<template>
  <div class="page">
    <navigation>查看订单</navigation>
    <div class=" repay-bank-detail">
      <div class="tips" >
        请注意，<span class="red">逾期将会产生罚息以及对你的信用产生影响</span>；请保证你的银行卡绑定有效以及余额充足
      </div>
      <div
        class="card-info"
        :class="{
          invalid: detail.bindStatus!== 'SUCCESS_AUTH',
        }"
        :style="{
          background: `linear-gradient(
           90deg,
           ${bankTheme[detail.bankCode]
           ? bankTheme[detail.bankCode][0]
           : bankTheme.DEFAULT[0]
          } 0%,
                 ${bankTheme[detail.bankCode]
           ? bankTheme[detail.bankCode][1]
           : bankTheme.DEFAULT[1]
          } 100%
       )`,
        }"
      >
        <img
          class="custom-icon bank-icon"
          :src="loadBankIcon(detail.bankCode)"
        />
        <div class="flex">
          <div class="bank-name">{{ detail.bankName }}</div>
          <div class="bankcard-no">
            {{ detail.cardNumber | cardNoFilter }}
          </div>
        </div>
        <span class="mask" @click="addBankCard">
          <img src="./images/icon_tanhao02@2x.png">
          银行卡已失效，请重新绑定 &gt;
        </span>
      </div>
      <template v-if="detail.orderList && detail.orderList.length">
        <div class="info-exp">下述订单或将在您的授权下从该银行执行扣款</div>
        <div class="loan-info" >
          <div class="item" @click="repaymentDetail(index)" v-for="(item,index) in detail.orderList" :key="index">
            <div class="loan-left">
              <p>借款： {{item.applyAmount| currency}}</p>
              <span>还款日：每月{{
                item.dueDate | date('D')
              }}日</span>
            </div>
            <div class="loan-right" :class="{'red':item.hasOverdue}">
              <p v-if="item.hasOverdue" >逾期应还 (元）</p>
              <p v-else>到期应还 (元）</p>
              <span>{{item.schdAmt | currency}}</span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>

</template>
<script >
import bankTheme from './components/bankcard/bank-theme'
import { mapActions } from 'vuex'
import dayjs from 'dayjs'
export default {
  data () {
    return {
      bankTheme,
      detail: {}
    }
  },
  filters: {
    cardNoFilter (val) {
      let str = '************' + String(val).substr(-4)
      return str.replace(/(.{4})/g, '$1 ')
    }
  },
  computed: {
    day () {
      return dayjs(this.detail.dueDate).format('DD')
    }
  },
  async created () {
    await this.repayLoanList()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('bankcard', ['repayLoanListX']),
    repaymentDetail (index) {
      const { orderId, productCd } = this.detail.orderList[index]
      this.$router.push(`/repayment/detail?orderId=${orderId}&loanPlatform=TMD&productCd=${productCd}`)
    },
    async repayLoanList () {
      const { success, data } = await this.repayLoanListX({
        cardNumber: this.$route.query.cardNumber
      })
      if (success) {
        this.detail = data || {}
      }
    },
    loadBankIcon (bankCode) {
      try {
        return require(`./images/${bankCode.toLowerCase()}.jpg`)
      } catch (e) {}
    },
    addBankCard () {
      const { notBindFundPartnerCds = [], cardNumber } = this.detail
      const params = {
        fundCode: notBindFundPartnerCds[0],
        bankcardNo: cardNumber,
        type: 'OVERDUE_BIND',
        canChangePhoneNo: true
      }
      this.$router.push({ path: '/bankcard/add', query: params })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.repay-bank-detail {
  min-height: 100vh;
  background: #fafafa;
  .tips {
    background: #ffecea;
    padding: 20px;
    font-size: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .red {
    color: #fb4a46;
  }
  .info-exp {
    padding: 0px 40px;
    font-size: 24px;
  }
  .card-info {
    display: flex;
    align-items: flex-start;
    overflow: hidden;
    height: 210px;
    border-radius: 30px;
    color: #fff;
    padding: 40px;
    margin: 40px;
    position: relative;
    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      display: flex;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
      display: none;
    }
    &.invalid {
      background: linear-gradient(90deg, #d3d3d3 0%, #e2e2e1 100%) !important;
      .mask {
        display: flex;
      }
    }
    .bank-icon {
      height: 50px;
      width: 50px;
      border-radius: 50%;
      margin-right: 18px;
    }
    .flex {
      flex: 1;
      .bank-name {
        font-size: 32px;
        font-weight: 400;
        line-height: 50px;
      }
      .bankcard-no {
        margin-top: 10px;
        font-size: 50px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        line-height: 60px;
      }
    }
  }
  .loan-info {
    
    padding: 30px;
    background: #fff;
    margin: 40px;
    border-radius: 20px;
   
    .item {
      justify-content: space-between;
      display: flex;
      margin-bottom: 20px;
      border-bottom: 1px solid #f7f7f7;
      padding-bottom: 20px;
      &:last-child{
        border-bottom: none;
        padding-bottom: 0;
      }
    }

    .loan-left {
      display: flex;
      flex-direction: column;
      p {
        color: #333;
      }
      span {
        color: #999;
      }
    }
    .loan-right {
      display: flex;
      flex-direction: column;
     
      position: relative;
      &:after {
        content: "";
        position: absolute;
        background: url("../../assets/images/arrow.png") no-repeat;
        background-size: 11px 20px;
        width: 11px;
        height: 20px;
        opacity: 0.4;
        right: 0px;
        top: 10px;
      }
      &.red{ color: #fb4a46;}
    }
    p {
      font-size: 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      padding-bottom: 10px;
    }
    span {
      font-size: 26px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
    }
  }
}
</style>